import { Navigate, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../layout/core'
import Account from './Account'
import BillingHistory from '../../components/account/billingHistory/Index'

const AccountPage = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Account</PageTitle>

      <Routes>
        <Route path='/all-account' element={<Account />} />
        <Route path='/billing-history/:uuid' element={<BillingHistory />} />
        <Route index element={<Navigate to='/account/all-account' />} />
      </Routes>
    </>
  )
}

export default AccountPage
